
const IndustriesSection = () => {
  const industries = [
    {
      icon: 'ri-hospital-line',
      name: 'Healthcare Systems',
      description: 'Comprehensive operational consulting for hospitals, clinics, and healthcare networks seeking accreditation and efficiency improvements.',
    },
    {
      icon: 'ri-truck-line',
      name: 'Transportation & Logistics',
      description: 'Strategic advisory for fleet operators, freight companies, and supply chain enterprises requiring compliance and optimization.',
    },
    {
      icon: 'ri-gas-station-fill',
      name: 'Energy & Fuel Retail',
      description: 'Market analysis and operational consulting for gas station owners, convenience store operators, and fuel distribution networks.',
    },
    {
      icon: 'ri-bank-line',
      name: 'Financial Services',
      description: 'Capital advisory and restructuring services for financial institutions, investment firms, and corporate finance departments.',
    },
    {
      icon: 'ri-government-line',
      name: 'Government & Public Sector',
      description: 'Policy consulting and operational advisory for government agencies, public institutions, and regulatory compliance initiatives.',
    },
    {
      icon: 'ri-building-line',
      name: 'Technology Enterprises',
      description: 'Digital transformation and IT infrastructure consulting for technology companies, startups, and enterprise software organizations.',
    },
  ];

  return (
    <section className="bg-charcoal-dark py-28 relative overflow-hidden">
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'linear-gradient(rgba(168, 144, 120, 0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(168, 144, 120, 0.5) 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }}></div>

      <div className="max-w-[1600px] mx-auto px-8 relative z-10">
        {/* Section Header */}
        <div className="mb-20">
          <p 
            className="text-sm uppercase tracking-[0.3em] mb-4"
            style={{
              background: 'linear-gradient(90deg, #7A6A5A 0%, #C4B8A8 50%, #7A6A5A 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Industries We Serve
          </p>
          <h2 className="text-4xl lg:text-5xl font-light text-white">
            Trusted Across{' '}
            <span 
              className="font-semibold"
              style={{
                background: 'linear-gradient(90deg, #7A6A5A 0%, #A89078 20%, #C4B8A8 40%, #D8CCC0 50%, #C4B8A8 60%, #A89078 80%, #7A6A5A 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Critical Sectors
            </span>
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="group bg-black/40 border border-gray-900 rounded-xl p-8 hover:border-copper/30 transition-all duration-300 cursor-pointer"
            >
              {/* Icon */}
              <div 
                className="w-12 h-12 flex items-center justify-center mb-5"
              >
                <i 
                  className={`${industry.icon} text-4xl`}
                  style={{
                    background: 'linear-gradient(90deg, #A89078 0%, #D8CCC0 50%, #A89078 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                ></i>
              </div>

              {/* Industry Name */}
              <h3 className="text-xl font-semibold text-white mb-3">
                {industry.name}
              </h3>

              {/* Description */}
              <p className="text-sm text-gray-500 leading-relaxed">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
